import React from 'react';
import { SparklesIcon, InstagramIcon, FacebookIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-nova-bone pt-20 pb-10 border-t border-nova-gray/10" data-id="element-54">
      <div className="max-w-7xl mx-auto px-6" data-id="element-55">
        <div className="grid md:grid-cols-4 gap-12 mb-16" data-id="element-56">
          <div className="md:col-span-2" data-id="element-57">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-58">
              <div className="w-8 h-8 rounded-lg bg-nova-dark flex items-center justify-center text-nova-cyan" data-id="element-59">
                <SparklesIcon size={16} data-id="element-60" />
              </div>
              <span className="font-black text-xl tracking-tight text-nova-dark" data-id="element-61">
                NOVA
              </span>
            </a>
            <p className="text-nova-gray max-w-sm mb-6" data-id="element-62">
              Redefiniendo la odontología con tecnología, diseño y un enfoque
              centrado en el bienestar del paciente.
            </p>
            <div className="flex gap-4" data-id="element-63">
              <a href="#" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-nova-dark hover:text-nova-cyan transition-colors" data-id="element-64">
                <InstagramIcon size={20} data-id="element-65" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-nova-dark hover:text-nova-cyan transition-colors" data-id="element-66">
                <FacebookIcon size={20} data-id="element-67" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-nova-dark hover:text-nova-cyan transition-colors" data-id="element-68">
                <LinkedinIcon size={20} data-id="element-69" />
              </a>
            </div>
          </div>

          <div data-id="element-70">
            <h4 className="font-bold text-nova-dark mb-6" data-id="element-71">Navegación</h4>
            <ul className="space-y-4" data-id="element-72">
              <li data-id="element-73">
                <a href="#servicios" className="text-nova-gray hover:text-nova-cyan transition-colors" data-id="element-74">
                  Servicios
                </a>
              </li>
              <li data-id="element-75">
                <a href="#equipo" className="text-nova-gray hover:text-nova-cyan transition-colors" data-id="element-76">
                  Equipo Médico
                </a>
              </li>
              <li data-id="element-77">
                <a href="#testimonios" className="text-nova-gray hover:text-nova-cyan transition-colors" data-id="element-78">
                  Testimonios
                </a>
              </li>
              <li data-id="element-79">
                <a href="#contacto" className="text-nova-gray hover:text-nova-cyan transition-colors" data-id="element-80">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-81">
            <h4 className="font-bold text-nova-dark mb-6" data-id="element-82">Legal</h4>
            <ul className="space-y-4" data-id="element-83">
              <li data-id="element-84">
                <a href="#" className="text-nova-gray hover:text-nova-cyan transition-colors" data-id="element-85">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="text-nova-gray hover:text-nova-cyan transition-colors" data-id="element-87">
                  Política de Privacidad
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-nova-gray/10 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-88">
          <p className="text-sm text-nova-gray" data-id="element-89">
            © {new Date().getFullYear()} NOVA Dental. Todos los derechos
            reservados.
          </p>
          <p className="text-sm text-nova-gray flex items-center gap-1" data-id="element-90">
            Diseñado con <SparklesIcon size={14} className="text-nova-cyan" data-id="element-91" />{' '}
            para tu sonrisa
          </p>
        </div>
      </div>
    </footer>;
}